import IncidentType from "types/IncidentType";
import { parseTimeToSeconds } from "./formatTime";

export const videoLabelsToIncidents = (
  videoLabels: any[],
  videoId: string,
  fps: number,
  incidentClasses: any[],
  options?: { idPrefix?: string; defaultColor?: string }
): IncidentType[] => {
  const idPrefix = options?.idPrefix || "";
  const defaultColor = options?.defaultColor || "#9e9e9e";

  return (videoLabels || []).map((vl: any, index: number) => {
    const matchedClass = incidentClasses.find(
      (c: any) => c.name === vl.tagName
    );
    const startSeconds = parseTimeToSeconds(vl.startTime);
    const endSeconds = parseTimeToSeconds(vl.endTime);

    return {
      id: `${idPrefix}${videoId}-${index}`,
      startFrame: Math.round(startSeconds * fps),
      endFrame: Math.round(endSeconds * fps),
      startTime: startSeconds,
      endTime: endSeconds,
      label: vl.tagName,
      class: {
        id: matchedClass?.id ?? vl.tagId ?? index,
        name: vl.tagName,
        color: matchedClass?.color || defaultColor,
        icon: matchedClass?.icon ?? null,
      },
      isFinished: true,
    };
  });
};
